/**
 * A Shareable is a simple wrapper for a set of sharable things and its type
 * @class
 * @extends Netx.Model
 */
import Base from '@netx/core/lib/netx-model';

import Collection from '@netx/core/lib/netx-collection';
import AssetSetModel from '@netx/core-asset/models/assetSet';

import {types as assetSetTypes} from '@netx/core-asset/properties/assetSets';

export default class Shareable extends Base {
	/** @type {object} */
	get defaults() {
		return {
			/** a type from Netx.ShareableTypes */
			type: '',
			/** array of object ids, */
			ids: [],
			/** optional array of models */
			models: [],
			/** optional array of collections */
			collections: [],
			/** label for the share options view */
			label: '',
		};
	}

	/**
	 * Constructor options: "type" (required) plus one of "ids", "model", "models" or "collection"
	 * For model/models, we extract the ids;
	 * For collection, we extract all the model IDs in the collection.
	 */
	constructor(attrs = {}, opts = {}) {
		if (!_.isString(attrs.type)) {
			throw new Error('new Shareable(opts): type not found');
		}

		const ids = attrs.ids,
			model = attrs.model,
			models = attrs.models,
			collection = attrs.collection;

		if (_.isArray(ids) && ids.length) {
			attrs.label =
				ids.length > 1 ? ids.length + ' ' + attrs.type + 's' : attrs.type;
		} else if (model && model instanceof Base) {
			attrs.ids = [model.id];
			attrs.models = [model];
			attrs.label = _.isFunction(model.getLabel)
				? '"' + model.getLabel() + '"'
				: attrs.type;
		} else if (_.isArray(models) && models.length) {
			attrs.ids = _.pluck(models, 'id');
			attrs.label =
				models.length +
				' ' +
				(models.length === 1 ? attrs.type.slice(0, -1) : attrs.type);
		} else if (
			collection &&
			collection instanceof Collection &&
			collection.length
		) {
			attrs.ids = _.pluck(collection.models, 'id');
			attrs.collections = [collection];
			attrs.label = attrs.type;
		}

		super(attrs, opts);

		// DEVNOTE: i am leaving open the possibility of someday sharing more than one collection,
		// by defining collections[] as an array.  But I'm not going to implement the rest until
		// it's needed.
		/*
		else if (_.isArray(opts.collections)) ... etc
		*/
	}

	/**
	 * For forwards- compatibility with the token system ...
	 */
	toAssetSet() {
		var aType;
		switch (this.get('type')) {
			case 'current cart':
				aType = assetSetTypes.cart;
				break;
			case 'saved cart':
				aType = assetSetTypes.savedCart;
				break;
			case 'saved search':
				aType = assetSetTypes.savedSearch;
				break;
			case 'assets':
				aType = assetSetTypes.asset;
				break;
		}

		return new AssetSetModel({
			ids: this.get('ids'),
			models: this.get('models'),
			label: this.get('label'),
			type: aType,
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'Shareable';
	}
}
